import React, { Component } from "react";
import { Link } from "react-router-dom";
import { signin, signInWithGoogle } from "../Utils/FirebaseAuth";
import { FormGroup, FormControl, Form, Button } from "react-bootstrap";
import toast, { Toaster } from 'react-hot-toast';

export default class FirebaseLogin extends Component {
  constructor() {
    super();
    this.state = {
      error: null,
      email: "",
      password: ""
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.googleSignIn = this.googleSignIn.bind(this);
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  async handleSubmit(event) {
    event.preventDefault();
    console.log(this.state.email.length);
    console.log(this.state.password.length);
    if((this.state.email.length ===0) || (this.state.password.length ===0))
    {
      toast.error('Email and password is required');
    }
    else{
      this.setState({ error: "" });
      try {
        await signin(this.state.email, this.state.password);
        toast.success('Congratulation you login successfully');
      } catch (error) {
        this.setState({ error: error.message });
        toast.error(this.state.error);
      }
    }
    // this.setState({ error: "" });
    // try {
    //   await signin(this.state.email, this.state.password);
    // } catch (error) {
    //   this.setState({ error: error.message });
    // }
  }

  async googleSignIn() {

    try {
      await signInWithGoogle();
    } catch (error) {
      this.setState({ error: error.message });
    }
  }


  render() {
    return (


      <div className='d-flex align-items-center mb-5'>
        <div className='flex-1 container'>
          <div className="signInDiv margin-top-100">
            <div>
              <p className='bold-font h4 text-center themeColor2 mb-3'>Sign In</p>
              <p className='para light-font text-center'>Welcome back. Please enter your credentials to login.</p>

              <div className='googleButton' onClick={this.googleSignIn.bind(this)}>
                <img width="30px" src='/Images/google-logo.ico' className='mr-3' />
                Sign In with Google
              </div>
              <div className='googleButton mt-2' >
                <img width="30px" src='/Images/facebook.png' className='mr-3' />
                Sign up with Facebook
              </div>
              <div className='position-relative my-5' >
                <div className='app-border mx-auto'></div>
                <span className='login-opt light-font para'>or Sign in with Email</span>
              </div>

              <form className='' onSubmit={this.handleSubmit}>
            <div className="form-group">
              <span className='bold-semifont para'>Email*</span>
              <input className="form-control" placeholder="Email" name="email" type="email" onChange={this.handleChange} value={this.state.email}></input>
            </div>
            <div className="form-group">
              <span className='bold-semifont para'>Password*</span>
              <input className="form-control" placeholder="Password" name="password" onChange={this.handleChange} value={this.state.password} type="password"></input>
            </div>
            <div className="form-group text-center">
              {/* {this.state.error ? (
                <p className="text-danger">{this.state.error}</p>
              ) : null} */}
              <Button className='round-button' type="submit">Login</Button>
            </div>
            {/* <p className='light-font'>You can also log in with any of these services</p> */}
            {/* <Button className="btn btn-danger mr-2" type="button" onClick={this.googleSignIn}>
              Sign in with Google
            </Button> */}

            {/* <hr /> */}
            <div className='app-border'></div>
            <p className='light-font'>
              Don't have an account? 
              {/* <Link to="/signup" style={{color:"#28b8dc"}}>Sign up</Link> */}
              <Link to="/testSignup" style={{color:"#28b8dc"}}>Sign up</Link>
            </p>
            <Toaster />
          </form>
           </div>
          </div>
        </div>
      </div>


    );
  }
}